// extracted by mini-css-extract-plugin
export default {"mention-token--active":"commentUtils_mention-token--active__tOise"};